import {AbstractEvent} from "@/modules/base/events";
import {YouthPlayer} from "@/modules/youth/entity";

export class BeforeYouthPlayerScoutingEvent extends AbstractEvent {
  constructor(
    public player: YouthPlayer,
    public progress: number,
  ) {
    super();
  }
}